export default function Main({ children, className, style }) {
  return (
    <main className={className} style={style}>
      {children}
    </main>
  );
}
